<template>
  <label class="font-16 text-grey-light">
    <slot />
  </label>
</template>

<script>
export default {
  name: 'SLabel',
};
</script>
